module.exports = __webpack_public_path__ + "static/media/twitter-square.726805c4.svg";